import { Map as map } from 'immutable';
const C = require("../constants");

function PartialOpenBoxSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.PARTIAL_OPEN_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default PartialOpenBoxSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/PartialOpenBoxSelectReducer.js